var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facts"
  }, [(_vm.company.breakfast_food || _vm.editable) ? _c('breakfast-food', _vm._b({}, 'breakfast-food', {
    company: _vm.company,
    editable: _vm.editable,
    breakfastFoods: _vm.breakfastFoods
  }, false)) : _vm._e(), _vm._v(" "), _vm._l((_vm.company.facts), function(fact) {
    return _c('company-fact', {
      attrs: {
        "editable": _vm.editable,
        "companyId": _vm.company.slug,
        "id": fact.id,
        "header": fact.header,
        "text": fact.text
      }
    })
  }), _vm._v(" "), (_vm.editable) ? _c('span', {
    staticClass: "small-icon-btn repeat-btn toggle-fun-fact",
    on: {
      "click": _vm.toggleForm
    }
  }, [_c('span', {
    staticClass: "ss-icon is-big"
  }, [_vm._v("plus")]), _c('a', {
    staticClass: "add_fields"
  }, [_vm._v(_vm._s(_vm.I18n.t('create_your_own_question')))])]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.showingForm) ? _c('form', {
    attrs: {
      "method": "post",
      "action": ("/companies/" + (_vm.company.slug) + "/facts")
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_header"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('question_title')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_text"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('your_answer')))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('footer', [_c('input', {
    staticClass: "cm-button save-changes",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    }
  })])]) : _vm._e()], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "name": "fact[header]",
      "id": "f_header",
      "required": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "name": "fact[text]",
      "id": "f_text",
      "required": "true"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a558ed18","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/facts.vue
// module id = null
// module chunks = 